import script from "./404.vue?vue&type=script&setup=true&lang=ts"
export * from "./404.vue?vue&type=script&setup=true&lang=ts"

import "./404.vue?vue&type=style&index=0&id=56fe92f1&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56fe92f1"]])

export default __exports__